import { render, staticRenderFns } from "./table-secondary.vue?vue&type=template&id=7c8d60c6&scoped=true&"
import script from "./table-secondary.vue?vue&type=script&lang=js&"
export * from "./table-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d60c6",
  null
  
)

export default component.exports